export const products = [
  {
    id: 1,
    name: "Super Chewer Bone",
    slug: "super-chewer-bone",
    price: 14.99,
    originalPrice: 19.99,
    rating: 4.8,
    reviewCount: 234,
    category: "dog-chew-toys",
    petType: "Dog",
    toyType: "Chew Toy",
    image: "https://images.unsplash.com/photo-1535294435445-d7249524ef2e?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1535294435445-d7249524ef2e?w=800&h=800&fit=crop",
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=800&fit=crop"
    ],
    description: "The ultimate chew toy for aggressive chewers. Made from natural rubber that's gentle on gums but tough enough to withstand hours of play.",
    features: ["Non-toxic natural rubber", "Bacon-flavored", "Cleans teeth while chewing", "Floats in water"],
    material: "100% Natural Rubber",
    recommendedSize: "Medium to Large Dogs (25-75 lbs)",
    isBestSeller: true,
    isNewArrival: false
  },
  {
    id: 2,
    name: "Squeaky Plush Duck",
    slug: "squeaky-plush-duck",
    price: 12.99,
    originalPrice: null,
    rating: 4.9,
    reviewCount: 456,
    category: "plush-pet-toys",
    petType: "Dog",
    toyType: "Plush Toy",
    image: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=800&h=800&fit=crop"
    ],
    description: "Adorable duck plushie with an irresistible squeaker. Perfect for fetch, cuddles, and endless entertainment.",
    features: ["Double-stitched seams", "Built-in squeaker", "Soft plush exterior", "Machine washable"],
    material: "Polyester Plush with Cotton Fill",
    recommendedSize: "All Dog Sizes",
    isBestSeller: true,
    isNewArrival: false
  },
  {
    id: 3,
    name: "Interactive Puzzle Feeder",
    slug: "interactive-puzzle-feeder",
    price: 24.99,
    originalPrice: 29.99,
    rating: 4.7,
    reviewCount: 189,
    category: "puzzle-toys",
    petType: "Dog",
    toyType: "Puzzle Toy",
    image: "https://images.unsplash.com/photo-1568640347023-a616a30bc3bd?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1568640347023-a616a30bc3bd?w=800&h=800&fit=crop"
    ],
    description: "Stimulate your dog's mind with this challenging puzzle feeder. Multiple difficulty levels keep them engaged.",
    features: ["3 difficulty levels", "Slows eating", "BPA-free materials", "Dishwasher safe"],
    material: "Food-grade ABS Plastic",
    recommendedSize: "Medium to Large Dogs",
    isBestSeller: true,
    isNewArrival: false
  },
  {
    id: 4,
    name: "Rainbow Rope Tug",
    slug: "rainbow-rope-tug",
    price: 9.99,
    originalPrice: null,
    rating: 4.6,
    reviewCount: 312,
    category: "rope-toys",
    petType: "Dog",
    toyType: "Rope Toy",
    image: "https://images.unsplash.com/photo-1576201836106-db1758fd1c97?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1576201836106-db1758fd1c97?w=800&h=800&fit=crop"
    ],
    description: "Colorful cotton rope toy perfect for tug-of-war and fetch. Helps clean teeth while playing.",
    features: ["100% cotton fibers", "Dental cleaning action", "Multiple knots for grip", "Durable construction"],
    material: "Natural Cotton Rope",
    recommendedSize: "All Dog Sizes",
    isBestSeller: true,
    isNewArrival: false
  },
  {
    id: 5,
    name: "Feather Wand Teaser",
    slug: "feather-wand-teaser",
    price: 8.99,
    originalPrice: null,
    rating: 4.9,
    reviewCount: 567,
    category: "cat-toys",
    petType: "Cat",
    toyType: "Interactive Toy",
    image: "https://images.unsplash.com/photo-1545249390-6bdfa286032f?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1545249390-6bdfa286032f?w=800&h=800&fit=crop"
    ],
    description: "Enticing feather wand that triggers your cat's natural hunting instincts. Hours of interactive fun!",
    features: ["Natural feathers", "Flexible wand", "Easy to wave", "Replaceable feathers"],
    material: "Wood Handle, Natural Feathers",
    recommendedSize: "All Cats",
    isBestSeller: true,
    isNewArrival: false
  },
  {
    id: 6,
    name: "Catnip Mouse Trio",
    slug: "catnip-mouse-trio",
    price: 7.99,
    originalPrice: 9.99,
    rating: 4.8,
    reviewCount: 423,
    category: "cat-toys",
    petType: "Cat",
    toyType: "Catnip Toy",
    image: "https://images.unsplash.com/photo-1574158622682-e40e69881006?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1574158622682-e40e69881006?w=800&h=800&fit=crop"
    ],
    description: "Set of 3 adorable mice filled with premium organic catnip. Watch your cat go wild!",
    features: ["Organic catnip", "3-pack value", "Realistic design", "Durable fabric"],
    material: "Felt with Organic Catnip",
    recommendedSize: "All Cats",
    isBestSeller: true,
    isNewArrival: false
  },
  {
    id: 7,
    name: "Bouncy Ball Set",
    slug: "bouncy-ball-set",
    price: 11.99,
    originalPrice: null,
    rating: 4.5,
    reviewCount: 178,
    category: "interactive-dog-toys",
    petType: "Dog",
    toyType: "Ball Toy",
    image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&h=800&fit=crop"
    ],
    description: "Set of 4 high-bounce balls in bright colors. Perfect for fetch and outdoor play.",
    features: ["4 pack", "High bounce", "Floats in water", "Bright colors"],
    material: "Non-toxic Rubber",
    recommendedSize: "All Dog Sizes",
    isBestSeller: false,
    isNewArrival: true
  },
  {
    id: 8,
    name: "Treat Dispensing Spinner",
    slug: "treat-dispensing-spinner",
    price: 19.99,
    originalPrice: 24.99,
    rating: 4.7,
    reviewCount: 245,
    category: "puzzle-toys",
    petType: "Dog",
    toyType: "Treat Toy",
    image: "https://images.unsplash.com/photo-1601758124510-52d02ddb7cbd?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1601758124510-52d02ddb7cbd?w=800&h=800&fit=crop"
    ],
    description: "Spinning treat dispenser that keeps dogs entertained and mentally stimulated.",
    features: ["Adjustable difficulty", "Holds dry treats", "Non-slip base", "Easy to clean"],
    material: "BPA-free Plastic",
    recommendedSize: "All Dog Sizes",
    isBestSeller: true,
    isNewArrival: false
  },
  {
    id: 9,
    name: "Laser Pointer Cat Toy",
    slug: "laser-pointer-cat-toy",
    price: 6.99,
    originalPrice: null,
    rating: 4.6,
    reviewCount: 389,
    category: "cat-toys",
    petType: "Cat",
    toyType: "Interactive Toy",
    image: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=800&h=800&fit=crop"
    ],
    description: "Safe LED laser pointer that provides endless entertainment for your cat.",
    features: ["Pet-safe laser", "Multiple patterns", "USB rechargeable", "Compact design"],
    material: "ABS Plastic",
    recommendedSize: "All Cats",
    isBestSeller: false,
    isNewArrival: true
  },
  {
    id: 10,
    name: "Crinkle Tunnel",
    slug: "crinkle-tunnel",
    price: 16.99,
    originalPrice: null,
    rating: 4.8,
    reviewCount: 267,
    category: "cat-toys",
    petType: "Cat",
    toyType: "Tunnel Toy",
    image: "https://images.unsplash.com/photo-1573865526739-10659fec78a5?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1573865526739-10659fec78a5?w=800&h=800&fit=crop"
    ],
    description: "Collapsible crinkle tunnel with peek holes. Perfect for hiding, playing, and napping.",
    features: ["Crinkle sound", "Collapsible design", "Peek holes", "Durable material"],
    material: "Polyester with Spring Frame",
    recommendedSize: "All Cats",
    isBestSeller: false,
    isNewArrival: true
  },
  {
    id: 11,
    name: "Durable Frisbee",
    slug: "durable-frisbee",
    price: 13.99,
    originalPrice: null,
    rating: 4.7,
    reviewCount: 198,
    category: "outdoor-pet-toys",
    petType: "Dog",
    toyType: "Outdoor Toy",
    image: "https://images.unsplash.com/photo-1558929996-da64ba858215?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1558929996-da64ba858215?w=800&h=800&fit=crop"
    ],
    description: "Flexible rubber frisbee that's gentle on teeth and flies straight every time.",
    features: ["Soft on teeth", "Floats on water", "High visibility", "Puncture resistant"],
    material: "Natural Rubber",
    recommendedSize: "Medium to Large Dogs",
    isBestSeller: false,
    isNewArrival: true
  },
  {
    id: 12,
    name: "Training Clicker Set",
    slug: "training-clicker-set",
    price: 5.99,
    originalPrice: null,
    rating: 4.9,
    reviewCount: 534,
    category: "training-toys",
    petType: "Dog",
    toyType: "Training Aid",
    image: "https://images.unsplash.com/photo-1544568100-847a948585b9?w=500&h=500&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1544568100-847a948585b9?w=800&h=800&fit=crop"
    ],
    description: "Professional training clickers with wrist straps. Perfect for positive reinforcement training.",
    features: ["2 pack", "Loud click sound", "Wrist strap", "Ergonomic design"],
    material: "ABS Plastic",
    recommendedSize: "All Dogs",
    isBestSeller: false,
    isNewArrival: false
  }
];

export const getProductBySlug = (slug) => {
  return products.find(product => product.slug === slug);
};

export const getProductsByCategory = (categorySlug) => {
  return products.filter(product => product.category === categorySlug);
};

export const getBestSellers = () => {
  return products.filter(product => product.isBestSeller);
};

export const getNewArrivals = () => {
  return products.filter(product => product.isNewArrival);
};

export const getRelatedProducts = (productId, limit = 4) => {
  const product = products.find(p => p.id === productId);
  if (!product) return [];
  return products
    .filter(p => p.id !== productId && (p.petType === product.petType || p.category === product.category))
    .slice(0, limit);
};
